<template>
    <div>
        <Verify
            @success="successFun"
            @closeVerifyBox="$emit('closeVerifyBox')"
            @refreshFun="$emit('refreshFun')"
            mode="pop"
            :verificationObject="verificationObject"
            :captchaType="captchaType"
            :imgSize="{ width: '330px', height: '155px' }"
            ref="verify">
        </Verify>
    </div>
</template>

<script>
//引入组件
import Verify from "@/components/verifition/Verify";
export default {
	components: {
		Verify
	},
    props: {
        captchaType: {
            type: String,
            default: "blockPuzzle" //1）滑动拼图 blockPuzzle 2）文字点选 clickWord,3)计算
        },
      verificationObject:{
        type: Object,
        default:null,
      },
    },
  watch: {
    captchaType: {
      immediate: true,
      handler() {

      }
    },
    verificationObject: {
      immediate: true,
      handler() {

      }
    },
  },
	methods:{
	    successFun(params){
            this.$emit("successFun", params)
	     // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
        },
        useVerify(){
            this.$refs.verify.show()
        }
	}
}
</script>
